import { getCallable } from "../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import {
    CreateCommentRequest, CreateCommentResponse,
    DeleteCommentRequest, DeleteCommentResponse,
    GetCommentsRequest, GetCommentsResponse,
    MarkCommentAsReadRequest, MarkCommentAsReadResponse,
    UpdateCommentRequest, UpdateCommentResponse
} from "./types";

const createComment = getCallable<CreateCommentRequest, CreateCommentResponse>(apiName, "createComment", {
    ...endpoints.createComment,
    composer: request => {
        return {
            url: `/comments`,
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const getComments = getCallable<GetCommentsRequest, GetCommentsResponse>(apiName, "getComments", {
    ...endpoints.getComments,
    composer: request => {
        const { presentationId, presentationLinkId } = request;

        const queryParams = new URLSearchParams();
        queryParams.set("presentationId", presentationId);
        if (presentationLinkId) {
            queryParams.set("presentationLinkId", presentationLinkId);
        }

        return {
            url: `/comments?${queryParams.toString()}`,
            options: {
                method: "GET"
            }
        };
    }
});

const updateComment = getCallable<UpdateCommentRequest, UpdateCommentResponse>(apiName, "updateComment", {
    ...endpoints.updateComment,
    composer: request => {
        return {
            url: `/comments/${request.id}`,
            options: {
                method: "PUT",
                body: JSON.stringify(request)
            }
        };
    }
});

const deleteComment = getCallable<DeleteCommentRequest, DeleteCommentResponse>(apiName, "deleteComment", {
    ...endpoints.deleteComment,
    composer: request => {
        return {
            url: `/comments/${request.id}`,
            options: {
                method: "DELETE",
                body: JSON.stringify(request)
            }
        };
    }
});

const markCommentAsRead = getCallable<MarkCommentAsReadRequest, MarkCommentAsReadResponse>(apiName, "markCommentAsRead", {
    ...endpoints.markCommentAsRead,
    composer: request => {
        return {
            url: `/comments/${request.id}/read`,
            options: {
                method: "PUT",
                body: JSON.stringify(request)
            }
        };
    }
});

export const callables = {
    createComment,
    getComments,
    updateComment,
    deleteComment,
    markCommentAsRead
};
